import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import home_background from "../Data/home_background.json"

const HomeSlider = () => {
    // State to handle the HomeSlider Background Transitions
    const [activeImg, setActiveImg] = useState(0)

    // Function to increment the state of actimeImg
    const nextImg = () => {
        setActiveImg((prevIndex) => {
            let newIndex = prevIndex + 1
            return checkNumber(newIndex)
        })
    }

    // Function to check if number is > array length
    const checkNumber = (number) => {
        if (number > home_background.length-1) {
            return 0
        }
        else {
            return number
        }
    }

    // UseEffect that automatically changes img every 4 seconds
    useEffect(() => {
        let slider = setInterval(() => {
            nextImg()
        }, 3000)
        // cleanup Function
        return () => {
        clearInterval(slider)
        }
    }, [activeImg])

  return (
    <>
        <div className="home-slider" id='#home-slider'>
            <div className="slider-overlay">
                {home_background.map((i) => {
                    return <img src={i.img} alt={i.name} key={i.id} id={i.id} className={i.id == activeImg ? "show-img" : "hide-img"}/>
                })}
                <div className="home-banner">
                    <div className="banner-title">
                        Find your perfect <span className="yellow">quote.<br></br></span>
                        Find your perfect <span className="yellow">rental car.</span>
                    </div>
                    <Link to="/about">
                        <button className="btn btn-lg btn-light know-more">Know More</button>
                    </Link>
                </div>
            </div>
        </div>
    </>
  )
}

export default HomeSlider